import * as React from "react";

import ComponentPage from "../../Components/ComponentPage";
import Anatomy from "../../Docs/Components/TextField/TextFieldAnatomy.mdx";
import Usage from "../../Docs/Components/TextField/TextFieldUsage.mdx";

import Examples from "../../Docs/Components/TextField/TextFieldExamples";
        
class Page extends React.Component {
public render() {
    return (
        <ComponentPage
            name="Text field"
            description="A text field can be used for the user to input and edit data."
            apiSources={["azure-devops-ui/Components/TextField/TextField.Props.d.ts"]}
            examples={Examples}
            status={{"design":"done","code":"done","docs":"done"}}
            anatomy={Anatomy}
            usage={Usage}
        />
    );
}
}
        
export default Page;